import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import {Location} from '@angular/common';

import { BasicValidators } from '../shared/basic-validators';
import {TransportadorasModel} from "./transportadoras.model";
import {TransportadorasService} from './transportadoras.service';
import {Funcoes} from "../funcoes";
import {Global} from "../global";


@Component({
  selector: 'app-transportadoras-form',
  templateUrl: './transportadoras-form.component.html'
})
export class TransportadorasFormComponent implements OnInit {

  form: FormGroup;
  title: string;
  transportadora: TransportadorasModel = new TransportadorasModel();
  pageIsUpd: boolean = false;
  pageIsAdd: boolean = false;
  enviando = false;

  constructor(
    formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private transportadorasService: TransportadorasService,
    private _location: Location,
    public func: Funcoes,
    public global: Global
  ) {
    this.form = formBuilder.group({
      id: [],
      nome: ['', [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(45)
      ]]
    });
  }

  ngOnInit() {

    // verifica se é uma página de edição
    if(this.router.url.split(/\//).pop() == 'upd'){
      this.pageIsUpd = true;
    }

    // verifica se é uma página para adicionar
    if(this.router.url.split(/\//).pop() == 'add'){
      this.pageIsAdd = true;
    }

    var id = this.route.params.subscribe(params => {
      var id = params['id_transportadora'];

      if(!this.pageIsUpd){
        this.title = this.func.traduzir('front.visualizarTransportadora');
      }else{
        this.title = id ? this.func.traduzir('front.editarTransportadora') : this.func.traduzir('front.cadastrarNovaTransportadora');
      }

      if (!id) {
        return;
      }

      this.transportadorasService.getById(id)
        .subscribe(
          json => {
            if(this.pageIsUpd) {
              this.title = this.func.traduzir('front.editarTransportadora')+': '+json.Payload[0].nome;
            }else{
              this.title = this.func.traduzir('front.visualizarTransportadora') + ': ' + json.Payload[0].nome;
            }

            this.transportadora = json.Payload[0];

            if(this.global.debug == true){
              console.log(json.Payload[0]);
            }
          },
          error => {
            this.func.showErro(error.json());
          });
    });
  }

  voltar() {
    this._location.back();
  }

  save() {
    this.enviando = true;
    var result,
      values = this.form.value;

    if (values.id) {
      result = this.transportadorasService.editar(values, values.id);
    } else {
      result = this.transportadorasService.adicionar(values);
    }

    result.subscribe(data => this.router.navigate(['/painel', 'laudos-cd', 'transportadoras']),
      error => {
        this.enviando = false;
        let json = error.json();
        this.func.showErro(json);

        if(json.Message && json.Message.ErrorInput){
          for(let i in json.Message.ErrorInput){
            let erro = {};
            erro[i] = json.Message.ErrorInput[i];
            this.form.controls[i].setErrors(erro);
          }
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/transportadoras/transportadoras-form.component.ts